export const SkillsData = [
   {
      type: "Frontend",
      list: [
         {
            name: "HTML",
            icon: <i class="devicon-html5-plain colored"></i>,
         },
         {
            name: "CSS",
            icon: <i class="devicon-css3-plain colored"></i>,
         },
         {
            name: "JavaScript",
            icon: <i class="devicon-javascript-plain colored"></i>,
         },
         {
            name: "TypeScript",
            icon: <i class="devicon-typescript-plain colored"></i>,
         },
         {
            name: "ReactJS",
            icon: <i class="devicon-react-original colored"></i>,
         },
         {
            name: "Next.JS",
            icon: <i class="devicon-nextjs-plain colored"></i>,
         },
         {
            name: "Redux",
            icon: <i class="devicon-redux-original colored"></i>,
         },
         {
            name: "Tailwind",
            icon: <i class="devicon-tailwindcss-plain colored"></i>,
         },
         {
            name: "MUI",
            icon: <i class="devicon-materialui-plain colored"></i>,
         },
         {
            name: "SASS",
            icon: <i class="devicon-sass-original colored"></i>,
         },
         {
            name: "Bootstrap",
            icon: <i class="devicon-bootstrap-plain colored"></i>,
         },
      ],
   },
   {
      type: "Other",
      list: [
         {
            name: "Git",
            icon: <i class="devicon-git-plain colored"></i>,
         },
         {
            name: "Jest",
            icon: <i class="devicon-jest-plain colored"></i>,
         },
         {
            name: "Figma",
            icon: <i class="devicon-figma-plain colored"></i>,
         },
      ],
   },
];
